import * as helpers from './helpers'

const defaultListReducer = helpers.createListReducerWithMapClicking({
  listViewName: 'skersprofili_list',
  actionsName: 'skersprofili'
})
export const skersprofili = (state = helpers.listGetInitialState(), {type, payload, reqId}) => {
  return defaultListReducer({state, type, payload, reqId})
}
